// Utils
import { getDomElementId } from '../../element/utils/elementUtil';
import getParentScrollableSection from './getParentScrollableSection';

/**
 * Finds the parent scrollable section element, given an element ID.
 * The parent scrollable section is either the Canvas or Inbox and is explicitly marked as such using
 * the custom data-scrollable DOM attribute.
 */
export default (elementId) => {
    const domElementId = getDomElementId(elementId);
    const domElement = document.getElementById(domElementId);
    return getParentScrollableSection(domElement);
};
